// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2izQ3","large":"styles_large__1w0w5"};